import React, { JSX } from "react";

import { CloseIcon, DateIcon } from "./utils";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

interface ToggleButtonProps {
  isEmpty: boolean;
}

const ToggleButton: React.FC<ToggleButtonProps> = (
  e: ToggleButtonProps
): JSX.Element => {
  return e.isEmpty ? (
    <DateIcon className={tw`"h-5 w-5`} />
  ) : (
    <CloseIcon className={tw`h-5 w-5`} />
  );
};

export default ToggleButton;
